export const PayloadMessageTypes = {
    error: "Error",
    info: "Info",
    failure: "Failure",
    success: "Success",
    warning: "Warning",
}


// WEBPACK FOOTER //
// ./src/common/message.js